

const peerConnectionOptions = {
  iceServers: [{
    urls: ['stun: stun.l.google.com: 19302']
  }]
}
// "{ \""iceServers\"": [{ \""urls\"": [\""stun: stun.l.google.com: 19302\""] }] }"
// node cirrus.js "--peerConnectionOptions=""$peerConnectionOptions""", "--PublicIp=$PublicIp"
